<h2>Borrar Medio de Verificación</h2> 
<div mat-dialog-content>
    ¿Está segura que desea <b>borrar</b> el medio de verificación seleccionado?
</div>
<div mat-dialog-actions>
  <button mat-button class="btn-cancelar" mat-dialog-close>Cancelar</button>
  <button mat-button class="btn-confirmar" (click)="confirmarEliminacion()">Borrar</button>
</div>